import state from './moduleOrgOwnerState.js';
import mutations from './moduleOrgOwnerMutations.js';
import actions from './moduleOrgOwnerActions.js';
import getters from './moduleOrgOwnerGetters.js';

export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters,
};
